import * as Sentry from "@sentry/nextjs";
import { Doc } from "@/convex/_generated/dataModel";

const identify = async (user: Doc<"users">) => {
    try {
        Sentry.setUser({
            id: user._id,
            email: user.email,
        });
    } catch (error) {
        console.error("Error identifying user:", error);
    }
};

export { identify };
